import Joi from 'joi';

export const ActivityBudgetSchema = Joi.object({
  subject: Joi.string().required(),
  activityDate: Joi.date().required(),
  amount: Joi.number().required(),
});
